export default __webpack_public_path__ + "images/BZ.5e3b9a5.png";